import {throttle} from '../utils/throttle';

const selectors = {
  progressBar: '[data-page-progress]',
};

export default function initPageScrollProgress(container) {
  const progressBar = container.querySelector(selectors.progressBar);
  const main = document.querySelector('.main-content');

  if (!progressBar || !main) return;

  const calcProgress = () => {
    const scrollDistance = -main.getBoundingClientRect().top;

    const progressPercentage = (scrollDistance / (main.offsetHeight - document.documentElement.clientHeight)) * 100;

    const progressRounded = Math.floor(progressPercentage);
    const widthPercentage = Math.min(Math.max(progressRounded, 0), 100);
    progressBar.style.width = `${widthPercentage}%`;
  };

  calcProgress();

  const updateProgressBar = throttle(calcProgress, 50);

  window.addEventListener('scroll', updateProgressBar);
}
